import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pulsa',
  templateUrl: './pulsa.component.html',
  styleUrls: ['./pulsa.component.css']
})
export class PulsaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
